import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'
import { Flex } from 'reflexbox'

import { SCHEDULE } from '../constants'
import T from 'i18n-react'
import Schedule from 'components/fulcrum/schedule/Schedule'
// import FulcrumDropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Dropdown from 'react-toolbox/lib/dropdown'
import Switch from 'react-toolbox/lib/switch';
import { 
    getMonthDayFullYear,
    getMonthDayYear } from 'helpers/DateUtil'
import SubmitButton from './SubmitButton'
import * as R from 'ramda'
const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

class ScheduleTab extends Component {
    constructor(props) {
        super(props)
        let initialState = {}
        if (props.scheduleInfo) {
            SCHEDULE.forEach((field) => {
                if (props.scheduleInfo[field]) {
                    let [year, month, day] = props.scheduleInfo[field].split("-")
                    let dateInput = [month, day, year.substring(2,4)].join("")
                    initialState = {
                        ...initialState,
                        [field]: {
                            enabled: props.scheduleInfo[field].length === 10,
                            date: props.scheduleInfo[field],
                            dateInput: dateInput
                        }
                    }
                } else {
                    initialState = {
                        ...initialState,
                        [field]: {
                            enabled: false,
                            date: "",
                            dateInput: ""
                        }
                    }
                }
            })
        }

        this.state = {
            ...initialState
        }
    }

    handleSwitchSelect = (key) => {
        let current = this.state[key]
        current.enabled = !current.enabled
        this.setState({
            [key]: current
        })
    }

    componentDidUpdate (prevProps) {
        let newState = {}
        if (!R.equals(prevProps.scheduleInfo, this.props.scheduleInfo)) {
            SCHEDULE.forEach((field) => {
                if (this.props.scheduleInfo[field]) {
                    let [year, month, day] = this.props.scheduleInfo[field].split("-")
                    let dateInput = [month, day, year.substring(2,4)].join("")
                    newState = {
                        ...newState,
                        [field]: {
                            enabled: this.props.scheduleInfo[field].length === 10,
                            date: this.props.scheduleInfo[field],
                            dateInput: dateInput
                        }
                    }
                } else {
                    newState = {
                        ...newState,
                        [field]: {
                            enabled: false,
                            date: "",
                            dateInput: ""
                        }
                    }
                }
            })
            this.setState({
                ...newState
            })
        }
    }
    handleUpdateDate = (date, key, other) => {
        let current = this.state[key]
        current.date = date
        current.dateInput = other.split("/").join("")
        this.setState({[`${key}`]: current})
    }

    updateDateInput = (input, key) => {
        let current = this.state[key]
        current.dateInput = input
        this.setState({ [`${key}`]: current})
    }

    cancelState = () => {
        this.setState({
            evt_start: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            dvt_start: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            pvt_start: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            pilot_start: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            mp_start: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            sbios_lock: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            whql_rc: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            whql_production: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            a_sample: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            b_sample: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            c_sample: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            d_sample: {
                enabled: false,
                date: "",
                dateInput: "",
            },
            sop_start: {
                enabled: false,
                date: "",
                dateInput: "",
            }
        })
    }

    render() {

        let enabledFields = {schedule: {}}
        Object.entries(this.state).forEach((field) => {
            if (field[1].enabled) {
                enabledFields.schedule = {
                    ...enabledFields.schedule,
                    [field[0]]: field[1]
                } 
            }
        })

        return(
            <div>
                <SubmitButton cancelState={this.cancelState} formDetails={enabledFields} formType="schedule" />
                <div styleName="scheduleEdit">
                    {SCHEDULE.map((key, index) => {
                        return (
                            <Flex key={index} styleName="scheduleDateContainer">
                                <Switch
                                    styleName="scheduleSwitch"
                                    checked={this.state[key].enabled}
                                    onChange={() => this.handleSwitchSelect(key)}
                                    />

                                <Schedule
                                    minDate={new Date()}
                                    label={T.translate('search.type.schedule.' + key)}
                                    input={this.state[key].dateInput}
                                    dateInput={this.state[key].date}
                                    onInputChange={(newInput) => this.updateDateInput(newInput, key)}
                                    onDateChange={(newDate) => this.handleUpdateDate(getMonthDayFullYear(new Date(newDate)), key, getMonthDayYear(newDate))}
                                    />
                            </Flex>                
                        )
                    })}
                </div>
            </div>
        )
    }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(ScheduleTab)